<header
  id="header"
  class="{{
    scrollevent ? 'header fixed-top header-scrolled' : 'header fixed-top'
  }}"
>
  <div
    class="container-fluid container-xl d-flex align-items-center justify-content-between"
  >
    <a href="index.html" class="logo d-flex align-items-center">
      <span>S9</span>
    </a>

    <nav
      id="navbar"
      class="{{ mobileToggleEvent ? 'navbar navbar-mobile' : 'navbar' }}"
    >
      <ul>
        <li *ngIf="!profile">
          <a (click)="loginTransporter()">
            <img src="assets/img/gg_profile.svg" /> Transporter Login
          </a>
        </li>
        <li>
          <!-- <a class="nav-link scrollto">
            <img src="assets/img/track.svg" /> Track</a
          > -->
        </li>
        <li *ngIf="loginSignup">
          <a class="getstarted scrollto" (click)="login('login')"
            >Customer Login</a
          >
        </li>
        <div class="dropdown" matTooltip="Profile" *ngIf="profile">
          <a mat-button [matMenuTriggerFor]="menu"
            ><img
              class="header-profile"
              src="{{ profilePic ? profilePic : 'assets/img/profilesimg.svg' }}"
            />Hi,
            <span style="text-transform: capitalize">{{ userName }}</span>
          </a>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="GoToProfile()">Profile</button>
            <div class="seperator"></div>
            <button mat-menu-item (click)="trips()">Trips</button>
            <div class="seperator"></div>
            <button mat-menu-item (click)="Logout()">Logout</button>
          </mat-menu>
        </div>
      </ul>
      <i
        class="{{
          mobileToggleEvent
            ? 'bi mobile-nav-toggle bi-x'
            : 'bi mobile-nav-toggle bi-list'
        }}"
        (click)="mobileToggle()"
      ></i>
    </nav>
    <!-- .navbar -->
  </div>
</header>
<section id="hero" class="hero d-flex align-items-center">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 d-flex flex-column justify-content-center">
        <h1 data-aos="fade-up">Redefining Trucking Experience</h1>
        <h2 data-aos="fade-up" data-aos-delay="400">
          One Stop for all your logistics needs.
        </h2>
        <div class="booking-area">
          <form [formGroup]="coordinatesForm">
            <div class="row booking-area-fields">
              <div class="input-fields">
                <mat-form-field
                  class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                  flex-gt-sm
                >
                  <span class="material-icons banner-icon">room</span>
                  <input
                    style="color: black; float: right"
                    formControlName="pickup"
                    (change)="onInputPickUpchange()"
                    #pickUpLocationSearchField
                    matInput
                    type="text"
                    placeholder="Pickup Area, City"
                    required
                  />
                  <span
                    class="material-icons close-icon"
                    *ngIf="showCloseIconPick"
                    (click)="clearPickField()"
                    >close</span
                  >
                </mat-form-field>
              </div>

              <div class="input-fields">
                <mat-form-field
                  class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                  flex-gt-sm
                >
                  <span class="material-icons banner-icon">room</span>
                  <input
                    (change)="onDropChange()"
                    style="color: black; float: right"
                    formControlName="drop"
                    #dropLocationSearchField
                    matInput
                    type="text"
                    placeholder="Drop Off Area, City"
                    required
                  />
                  <span
                    class="material-icons close-icon"
                    *ngIf="showCloseIconDrop"
                    (click)="clearDropField()"
                    >close</span
                  >
                </mat-form-field>
              </div>
              <div class="input-fields input-fields-two-items">
                <mat-form-field
                  class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                  flex-gt-sm
                >
                  <input
                    matInput
                    [matDatepicker]="picker1"
                    placeholder="Pickup Date"
                    [min]="minDate"
                    [max]="maxDate"
                    formControlName="date"
                    (click)="picker1.open()"
                    required
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker1">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
                <mat-form-field
                  class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width truck-type-input"
                  flex-gt-sm
                >
                  <mat-select
                    dropLocationSearchField
                    placeholder="Truck Category"
                    formControlName="truck_category"
                    (selectionChange)="GetTruckWeight()"
                    required
                  >
                    <mat-option>Select Truck category</mat-option>
                    <mat-option
                      *ngFor="let cat of truckCategory"
                      value="{{ cat._id }}"
                      >{{ cat.truck_category_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="input-fields-last" *ngIf="user != 'corporate'">
                <mat-form-field
                  class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                  flex-gt-sm
                >
                  <mat-select
                    dropLocationSearchField
                    formControlName="truck_type"
                    required
                  >
                    <mat-option value="">Select Truck Type</mat-option>
                    <mat-option
                      *ngFor="let item of truckWeight"
                      value="{{ item._id }}"
                      >{{ item.truck_weight.replace(' ', '') }} {{ item.truck_feet.replace(' ', '') }} {{ item.minimum_amount }}W</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </form>
          <div class="row p-0">
            <button class="sheer" (click)="requestQuote()">Search</button>
          </div>
        </div>
        <div data-aos="fade-up" data-aos-delay="600"></div>

        <!-- Available Routes Section -->
        <div class="available-routes-container" *ngIf="availableRoutes && availableRoutes.length > 0" data-aos="fade-up" data-aos-delay="500">
          <div class="available-routes-header">
            <h3 class="available-routes-title">Available Routes</h3>
            <a class="view-all-routes-btn" *ngIf="availableRoutes.length > 6" (click)="viewAllRoutes()">
              {{ showAllRoutes ? 'Show less' : 'View all routes' }}
              <span class="arrow-icon" *ngIf="!showAllRoutes">&rarr;</span>
              <span class="arrow-icon" *ngIf="showAllRoutes">&uarr;</span>
            </a>
          </div>

          <div class="available-routes-grid">
            <div class="available-route-card" *ngFor="let route of (showAllRoutes ? availableRoutes : (availableRoutes | slice:0:6)); let i = index">
              <!-- Left Content Area -->
              <div class="route-card-left">
                <!-- Route Heading (e.g. Hyderabad -> Bangalore) -->
                <div class="route-locations">
                  <span class="location-name">{{ route.from }}</span>
                  <span class="route-arrow">&rarr;</span>
                  <span class="location-name">{{ route.to }}</span>
                </div>

                <!-- Truck Type Tag (Blue) -->
                <div class="route-truck-blue">
                  {{ route.truck_type_name }}
                </div>

                <!-- 3 Spec Badges -->
                <div class="route-specs-row">
                  <!-- Truck Category -->
                  <div class="spec-col">
                    <div class="spec-label-with-icon">
                      <svg class="spec-svg-icon" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="1" y="3" width="15" height="13"></rect>
                        <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                        <circle cx="5.5" cy="18.5" r="2.5"></circle>
                        <circle cx="18.5" cy="18.5" r="2.5"></circle>
                      </svg>
                      <span>Category</span>
                    </div>
                    <div class="spec-value">{{ route.truck_category_name }}</div>
                  </div>

                  <!-- Truck Type -->
                  <div class="spec-col">
                    <div class="spec-label-with-icon">
                      <svg class="spec-svg-icon" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M5 18H3c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1h-2"></path>
                        <circle cx="7" cy="18" r="2"></circle>
                        <circle cx="17" cy="18" r="2"></circle>
                        <path d="M14 9h4l3 3v5h-2"></path>
                      </svg>
                      <span>Type</span>
                    </div>
                    <div class="spec-value">{{ route.truck_type_name }}</div>
                  </div>

                  <!-- Available Trucks -->
                  <div class="spec-col">
                    <div class="spec-label-with-icon">
                      <svg class="spec-svg-icon" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                      </svg>
                      <span class="text-available-trucks">Available</span>
                    </div>
                    <div class="spec-value text-blue-bold">{{ route.available_trucks }}</div>
                  </div>
                </div>
              </div>

              <!-- Right Action / Price Box -->
              <div class="route-card-right">
                <!-- Price / Login View -->
                <div class="price-lock-section">
                  <div *ngIf="!token" class="lock-login-prompt">
                    <svg class="lock-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                    <span class="login-to-view-text">Login to<br />view price</span>
                  </div>
                  <div *ngIf="token" class="price-display">
                    <span class="currency-symbol">₹</span>
                    <span class="price-amount">{{ route.price | number:'1.0-0' }}</span>
                  </div>
                </div>

                <!-- Reserve a Trip Button -->
                <button class="btn-reserve-trip" (click)="reserveAvailableTrip(route)">
                  Reserve a Trip
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
